import React from 'react';
import Modal from '../shared/Modal';
import { Link } from 'react-router-dom';

const MenusCreateModal = props => {
  const { isOpen, closeModal } = props;
  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal}>
      <div className="admin-wrapper">
        <h1 className="h2 modal__heading">Menu Type</h1>
        <div className="modal__p">
          <p className="p">Which menu type would you like to create?</p>
        </div>

        <div className="form__row">
          <div className="form__row-item--half">
            <Link
              to="/admin/menu/create/weekly"
              className="btn btn--hollow-blue btn--full-width"
            >
              Weekly
            </Link>
          </div>
          <div className="form__row-item--half">
            <Link
              to="/admin/menu/create/occasion"
              className="btn btn--hollow-blue btn--full-width"
            >
              Occasion
            </Link>
          </div>
        </div>
        <div className="form__row">
          <div className="form__row-item--half ">
            <Link
              to="/admin/menu/create/evergreen"
              className="btn btn--hollow-blue btn--full-width"
            >
              Evergreen
            </Link>
          </div>
          <div className="form__row-item--half ">
            <Link
              to="/admin/menu/create/company"
              className="btn btn--hollow-blue btn--full-width"
            >
              Company
            </Link>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MenusCreateModal;



// WEBPACK FOOTER //
// ./src/components/menus/MenusCreateModal.js